// 首页统计数据
import request from '@/untils/request'

// 查询菜单列表
export function listMenu(query) {
    return request({
        url: '/system/menu/list',
        method: 'get',
        params: query
    })
}

// 查询菜单详细
export function getMenu(menuId) {
    return request({
        url: '/system/menu/' + menuId,
        method: 'get'
    })
}

// 新增菜单
export function addMenu(data) {
    return request({
        url: '/system/menu',
        method: 'post',
        data: data
    })
}

// 修改菜单
export function updateMenu(data) {
    return request({
        url: '/system/menu',
        method: 'put',
        data: data
    })
}

// 删除菜单
export function delMenu(menuId) {
    return request({
        url: '/system/menu/' + menuId,
        method: 'delete'
    })
}

// 获取菜单树选择
export function getMenuTreeSelect() {
    return request({
        url: '/system/menu/treeselect',
        method: 'get'
    })
}

// 根据角色获取菜单树选择
export function getMenuTreeSelectByRole(roleId) {
    return request({
        url: '/system/menu/roleMenuTreeselect/' + roleId,
        method: 'get'
    })
}

// 根据角色获取菜单树选择
export function getRouters() {
    return request({
        url: '/system/menu/getRouters',
        method: 'get'
    })
}